/* Keep every product add-to-cart button in sync with the live cart, including tabs opened before the cart changed. */
(function () {
  if (window.__alreadyInCartInit) return;
  window.__alreadyInCartInit = true;

  var accessToken = '478ee9af2b076ca2b2e341661c1f7b4f';
  var storeDomain = '/api/2023-10/graphql.json';
  var storageKey = 'cme-cart-sync';
  var requestSeq = 0;
  var lastCart = null;
  var lastPublished = null;
  var scheduleTimer = null;
  var handleToProductId = {};
  var channel = null;

  try {
    if (typeof BroadcastChannel !== 'undefined') {
      channel = new BroadcastChannel('cme-cart');
      channel.onmessage = function (event) {
        if (!event || event.data == null || event.data === lastPublished) return;
        update();
      };
    }
  } catch (e) {}

  function extractNumericId(gid) {
    try {
      var match = String(gid).match(/\/(\d+)$/);
      return match ? match[1] : null;
    } catch (e) {
      return null;
    }
  }

  function currentText(button) {
    var span = button.querySelector('.text');
    return (span ? span.textContent : button.textContent || '').trim();
  }

  function labelFor(button) {
    var label = button.getAttribute('data-label') || button.getAttribute('data-atc-original-text') || 'Add to Cart';
    if (label.charAt(0) === '"' && label.charAt(label.length - 1) === '"') {
      try { label = JSON.parse(label); } catch (e) {}
    }
    return label;
  }

  function setText(button, text) {
    var span = button.querySelector('.text');
    if (span) {
      span.className = 'text';
      span.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function clearStyles(button) {
    button.style.backgroundColor = '';
    button.style.color = '';
    button.style.cursor = '';
    button.style.pointerEvents = '';
    button.style.transition = '';
    button.style.opacity = '';
  }

  function captureOriginal(button) {
    if (button.hasAttribute('data-atc-original-text')) return;
    var current = currentText(button);
    if (/^already in cart$/i.test(current)) {
      button.setAttribute('data-atc-original-text', labelFor(button));
      button.setAttribute('data-atc-was-disabled', 'false');
      return;
    }
    button.setAttribute('data-atc-original-text', current || labelFor(button));
    var unavailable = button.closest('.product-is-unavailable');
    button.setAttribute('data-atc-was-disabled', unavailable ? 'true' : 'false');
  }

  function lockButton(button) {
    captureOriginal(button);
    button.setAttribute('data-atc-locked', 'true');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('disabled');
    button.style.backgroundColor = 'gray';
    button.style.color = 'white';
    button.style.cursor = 'not-allowed';
    button.style.pointerEvents = 'none';
    button.style.transition = 'none';
    button.style.opacity = '1';
    setText(button, 'Already in Cart');
    var check = button.querySelector('.checkmark');
    if (check) check.classList.remove('checkmark-active');
  }

  function unlockButton(button) {
    var showingAlready = button.getAttribute('data-atc-locked') === 'true' || /^already in cart$/i.test(currentText(button));
    if (!showingAlready) return;

    var wasDisabled = button.getAttribute('data-atc-was-disabled') === 'true';
    var label = wasDisabled ? (button.getAttribute('data-atc-original-text') || labelFor(button)) : labelFor(button);
    button.removeAttribute('data-atc-locked');
    button.removeAttribute('aria-disabled');
    clearStyles(button);
    setText(button, label);

    if (wasDisabled) {
      button.disabled = true;
      button.classList.add('disabled');
      return;
    }

    button.disabled = false;
    button.classList.remove('disabled');

    if (!button.closest('form[action*="/cart/add"]')) {
      try {
        if (sessionStorage.getItem('cme-atc-reloaded') === '1') return;
        sessionStorage.setItem('cme-atc-reloaded', '1');
      } catch (e) {}
      window.location.reload();
    }
  }

  function setBuyNow(root, inCart) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('.shopify-payment-button');
    for (var i = 0; i < nodes.length; i++) {
      if (inCart) {
        nodes[i].setAttribute('data-atc-buy-now-hidden', 'true');
        nodes[i].style.display = 'none';
      } else if (nodes[i].getAttribute('data-atc-buy-now-hidden') === 'true') {
        nodes[i].removeAttribute('data-atc-buy-now-hidden');
        nodes[i].style.display = '';
      }
    }
  }

  function collectButtons() {
    var nodes = document.querySelectorAll('[data-product-atc], form[action*="/cart/add"] button.add_to_cart, form[action*="/cart/add"] input.add_to_cart');
    var buttons = [];
    for (var i = 0; i < nodes.length; i++) {
      var button = nodes[i];
      if (button.hasAttribute('data-minicart-checkout-button')) continue;
      if (button.hasAttribute('data-cart-checkout-button')) continue;
      if (button.getAttribute('name') === 'checkout') continue;
      if (buttons.indexOf(button) !== -1) continue;
      buttons.push(button);
    }
    return buttons;
  }

  function contextFor(button) {
    var root = button.closest('[data-product-form]') || button.closest('[data-product-id]') || button;
    var productId = button.getAttribute('data-product-id') || root.getAttribute('data-product-id');
    var productType = button.getAttribute('data-product-type') || root.getAttribute('data-product-type') || '';
    var productHandle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle') || '';
    var form = button.closest('form[action*="/cart/add"]');
    if (!form && root.querySelector) form = root.querySelector('form[action*="/cart/add"]');

    var variantId = null;
    if (form) {
      var select = form.querySelector('[name="id"]');
      if (select && select.value) variantId = select.value;
    }
    if (!variantId) {
      try {
        variantId = new URLSearchParams(window.location.search).get('variant');
      } catch (e) {}
    }

    var childHandle = null;
    var sku = null;
    if (variantId && /^\d+$/.test(String(variantId))) {
      var variantData = document.querySelector('.variant-data[data-variant-id="' + variantId + '"]');
      if (variantData) childHandle = variantData.getAttribute('data-sub-product-handle');
      if (window.variantSkuMap && window.variantSkuMap[variantId]) sku = window.variantSkuMap[variantId];
      if (!sku && form) {
        var option = form.querySelector('option[value="' + variantId + '"]');
        if (option) sku = option.getAttribute('data-sku');
      }
    }

    return {
      button: button,
      root: root,
      productId: productId,
      productHandle: productHandle,
      form: form,
      variantId: variantId,
      sku: sku,
      childHandle: childHandle,
      isCombined: productType === 'Combined'
    };
  }

  function propertyMatch(item, handle, sku) {
    try {
      var props = item.properties || {};
      var values = Object.keys(props).map(function (key) { return String(props[key] || '').toLowerCase(); });
      var handleValue = handle ? String(handle).toLowerCase() : null;
      var skuValue = sku ? String(sku).toLowerCase() : null;
      if (handleValue && values.some(function (value) { return value === handleValue || value.indexOf(handleValue) !== -1; })) return true;
      if (skuValue && values.some(function (value) { return value === skuValue || value.indexOf(skuValue) !== -1; })) return true;
    } catch (e) {}
    return false;
  }

  function itemMatches(item, ctx) {
    if (ctx.productId && String(item.product_id) === String(ctx.productId)) return true;
    if (!ctx.isCombined) return false;
    if (ctx.productHandle && item.handle === ctx.productHandle) return true;
    if (ctx.childHandle && item.handle === ctx.childHandle) return true;
    if (ctx.variantId && (String(item.id) === String(ctx.variantId) || String(item.variant_id) === String(ctx.variantId))) return true;
    if (ctx.sku && item.sku && String(item.sku) === String(ctx.sku)) return true;
    if (ctx.sku && item.variant_title && String(item.variant_title).indexOf(String(ctx.sku)) !== -1) return true;
    if (propertyMatch(item, ctx.childHandle || ctx.productHandle, ctx.sku)) return true;
    if (ctx.childHandle && handleToProductId[ctx.childHandle] && String(item.product_id) === String(handleToProductId[ctx.childHandle])) return true;
    return false;
  }

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      return [item.product_id, item.variant_id || item.id, item.quantity, item.sku || '', item.handle || ''].join(':');
    }).join('|');
  }

  function publish(signature) {
    if (signature === lastPublished) return;
    lastPublished = signature;
    try { localStorage.setItem(storageKey, signature + '|' + Date.now()); } catch (e) {}
    try { if (channel) channel.postMessage(signature); } catch (e) {}
  }

  function lookupChild(handle, cart, seq, button) {
    if (handleToProductId[handle]) {
      var knownId = handleToProductId[handle];
      var known = cart.items.some(function (item) { return String(item.product_id) === String(knownId); });
      if (seq !== requestSeq) return;
      if (known) lockButton(button);
      else unlockButton(button);
      return;
    }

    var query = '{ product(handle: "' + String(handle).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"){ id } }';
    fetch(storeDomain, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query: query })
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (seq !== requestSeq) return;
        var gid = json && json.data && json.data.product && json.data.product.id;
        var numericId = gid ? extractNumericId(gid) : null;
        if (!numericId) {
          unlockButton(button);
          return;
        }
        handleToProductId[handle] = numericId;
        var found = cart.items.some(function (item) { return String(item.product_id) === String(numericId); });
        if (found) lockButton(button);
        else unlockButton(button);
      })
      .catch(function () {});
  }

  function applyCart(cart, seq) {
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;
    var buttons = collectButtons();

    buttons.forEach(captureOriginal);
    buttons.forEach(function (button) {
      var ctx = contextFor(button);
      if (!ctx.productId && !ctx.isCombined) return;
      var matched = cart.items.some(function (item) { return itemMatches(item, ctx); });
      if (matched) {
        lockButton(button);
        setBuyNow(ctx.root, true);
        return;
      }
      if (ctx.isCombined && ctx.childHandle) {
        lookupChild(ctx.childHandle, cart, seq, button);
        return;
      }
      unlockButton(button);
      setBuyNow(ctx.root, false);
    });

    publish(cartSignature(cart));
  }

  function update() {
    var seq = ++requestSeq;
    fetch('/cart.js?_=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (seq !== requestSeq) return;
        applyCart(cart, seq);
      })
      .catch(function () {});
  }

  function scheduleUpdate() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(update, 50);
  }

  window.updateAlreadyInCartButtons = function () {
    if (lastCart) applyCart(lastCart, requestSeq);
    scheduleUpdate();
  };

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail;
    if (!cart || !Array.isArray(cart.items)) {
      update();
      return;
    }
    applyCart(cart, ++requestSeq);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    if (form.querySelector('[data-atc-locked="true"]')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.ajax-submit, [data-product-atc]') : null;
    if (!button) return;
    if (button.getAttribute('data-atc-locked') === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    setTimeout(update, 1200);
    setTimeout(update, 1800);
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-product-form], form[action*="/cart/add"]')) scheduleUpdate();
  });

  document.addEventListener('variantChanged', scheduleUpdate);

  window.addEventListener('pageshow', function () {
    update();
  });

  window.addEventListener('focus', scheduleUpdate);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') update();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) update();
  });

  window.addEventListener('popstate', scheduleUpdate);

  function nodeHasAddToCart(node) {
    if (!node || node.nodeType !== 1) return false;
    var selector = '[data-product-atc], form[action*="/cart/add"], [data-product-form]';
    if (node.matches && node.matches(selector)) return true;
    return !!(node.querySelector && node.querySelector(selector));
  }

  if (window.MutationObserver && document.body) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var n = 0; n < added.length; n++) {
          if (nodeHasAddToCart(added[n])) {
            scheduleUpdate();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  try {
    if (document.querySelector('form[action*="/cart/add"]')) {
      sessionStorage.removeItem('cme-atc-reloaded');
    }
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  setTimeout(update, 400);
})();
